import { Component, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./home-styles.js";

// A thrown render error unmounts the whole tree, which for this app means a
// white page with no way forward. Anything the customer can read and act on
// is better, especially on the checkout.
class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" style={{ fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif", maxWidth: "26rem", margin: "18vh auto 0", padding: "0 1.5rem", textAlign: "center", color: "#101418" }}>
        <h1 style={{ fontSize: "1.2rem", margin: "0 0 0.6rem" }}>Something went wrong</h1>
        <p style={{ margin: "0 0 1.4rem", lineHeight: 1.5, color: "#666d73" }}>This page could not be shown. No payment has been taken. Please try again.</p>
        <button type="button" onClick={() => window.location.reload()} style={{ font: "inherit", fontWeight: 600, color: "#fff", background: "#101418", border: 0, borderRadius: "10px", padding: "0.8rem 1.4rem", cursor: "pointer" }}>Reload page</button>
      </div>
    );
  }
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);

// The shell's boot guard (see bootGuardPlugin in vite.config.js) marks that it
// has already retried and adds a cache-busting parameter. Clearing both once
// the app is running keeps the address bar clean and leaves the guard free to
// recover again in a later session.
try {
  window.sessionStorage.removeItem("boot-retry");
} catch {
  // Private-mode browsers can block storage; the guard copes without it.
}

const url = new URL(window.location.href);
if (url.searchParams.has("boot")) {
  url.searchParams.delete("boot");
  window.history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
}
